export const API = {
  auth: {
    login: '/admin/login'
  },
  users: {
    list: '/admin/users',
    filters: '/admin/users/filters',
    create: '/admin/users/create',
    get: (id) => `/admin/users/${id}`,
    update: (id) => `/admin/users/${id}`,
    role: (id) => `/admin/users/role/${id}`,
    disposableToken: (id) => `/admin/users/get-disposable-token/${id}`
  },
  areas: {
    all: '/admin/areas?all=true',
    update: '/admin/areas',
    create: '/admin/areas/create',
    delete: (id) => `/admin/areas/delete/${id}`,
    filter: '/admin/areas/filter',
    polygons: '/admin/areas/polygons'
  },
  cars: {
    list: '/admin/cars'
  },
  rates: {
    get: '/admin/rates',
    update: '/admin/rates'
  },
  discounts: {
    filter: '/admin/discounts/filter',
    create: '/admin/discounts/create',
    update: '/admin/discounts',
    delete: '/admin/discounts/delete',
    archive: '/admin/discounts/archive',
    calendar: '/admin/discounts/callendar'
  },
  roles: {
    list: '/admin/roles',
    listEditable: (edit) => `/admin/roles?edit=${edit}`,
    create: '/admin/roles',
    update: (id) => `/admin/roles/${id}`,
    delete: (id) => `/admin/roles/${id}`
  },
  auditLog: {
    filters: '/admin/audi-log/filters',
    list: '/admin/audit-log'
  },
  centrifugo: {
    refreshToken: '/centrifuge/refresh-token'
  },
  calc: {
    oneWay: 'dashboard/price/cars',
    hourly: 'dashboard/price/cars/hourly'
  }
}
